// @ts-nocheck
import { CustomerLocation, useLoadLocation } from "@store/Framework/Store/Bunzl/Pages/Reporting/LoadLocations";
import { reportParametersSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencySelectors";
import useUpdateReportSearchFields from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useUpdateSearchFields";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function useLocation() {
    const loadLocation = useLoadLocation();
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const reportApiParams = useSelector(reportParametersSelector);
    const updateReportSearchFields = useUpdateReportSearchFields();

    const isSelected = (customerId: string) => {
        return selectedItems.includes(customerId);
    };
    useEffect(() => {
        loadLocation();
    }, []);
    useEffect(() => {
        updateReportSearchFields({
            ...reportApiParams,
            customers: selectedItems,
        });
    }, [selectedItems]);
    useEffect(() => {
        if (selectedItems.length > reportApiParams?.customers.length) {
            setSelectedItems([]);
        }
    }, [reportApiParams.customers]);

    const toggleItem = (item: string) => {
        if (isSelected(item)) {
            const updatedSelectedItems = selectedItems.filter(selectedItem => selectedItem !== item);
            setSelectedItems(updatedSelectedItems);
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };
    const toggleAllCompanyCustomers = (customerLocations: CustomerLocation[]) => {
        const selectedCustomers = customerLocations.filter(customerLocation =>
            selectedItems.includes(customerLocation.id),
        );
        if (selectedCustomers.length === customerLocations.length) {
            const newSelectedItems = selectedItems.filter(item => {
                return !selectedCustomers.map(customer => customer.id).includes(item);
            });
            setSelectedItems([...new Set(newSelectedItems)]);
        } else {
            setSelectedItems([...new Set([...selectedItems, ...customerLocations.map(customer => customer.id)])]);
        }
    };

    return {
        selectedItems,
        toggleItem,
        toggleAllCompanyCustomers,
        setSelectedItems,
    };
}

export default useLocation;
